/**
 * 缓存搜索条件
 */

const cacheKey = 'search-condition'

// 缓存数据
function set(data) {
  const cache = get()
  if(cache) {
    data = Object.assign(cache, data)
  }
  localStorage.setItem(cacheKey, JSON.stringify(data))
}

// 获取数据
function get() {
  const data = localStorage.getItem(cacheKey)
  return JSON.parse(data)
}

// 获取数据
function getFromIframe(iframe) {
  const data = get()
  iframe.contentWindow.postMessage({action: 'search-condition-respond', data: data}, '*')
}

export default {
  set,
  get,
  getFromIframe
}



// WEBPACK FOOTER //
// ./src/assets/js/search_condition.js